import axios from 'axios';
import { toast } from 'react-toastify';
import * as Sentry from '@sentry/nextjs';
import createAuthRefreshInterceptor from 'axios-auth-refresh';

const refreshAuthLogic = (failedRequest) =>
  axios.get('api/auth/token').then((tokenRefreshResponse) => {
    localStorage.setItem('accessToken', tokenRefreshResponse.data.accessToken);
    failedRequest.response.config.headers['Authorization'] =
      'Bearer ' + tokenRefreshResponse.data.accessToken;
    return Promise.resolve();
  });

export const axiosInstance = (token?: string) => {
  const instance = axios.create({
    baseURL: process.env.NEXT_PUBLIC_API_URL,
    headers: {
      ...token ? { Authorization: 'Bearer ' + token } : {},
      'sl-domain': process.env.NEXT_PUBLIC_APP_SUBDOMAIN
    },
  });

  createAuthRefreshInterceptor(instance, refreshAuthLogic);

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error?.response?.status === 401) {
        return Promise.resolve()
      }

      if (error?.response?.status >= 500) {
        Sentry.captureException(error);
      }

      if (error?.response && error.response?.data) {
        toast.error(
          error.response?.data?.error?.message || error?.response?.data?.message
        );
        return Promise.reject(error.response?.data);
      }
      return Promise.reject(error?.message);
    }
  );

  return instance;
};
